import React from 'react';

class Footer extends React.Component {
    render() {
        return (
            <div id="footer">
                <div className="inner">
                    <ul className="icons">
                        <li>
                            <a
                                href="mailto:frank@undiscoveredsoftware.com"
                                className="icon fa-envelope-o"
                            >
                                <span className="label">Email</span>
                            </a>
                        </li>
                    </ul>
                    <ul className="copyright">
                        <li>&copy; Frank Wanicka 2018</li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js